'use strict';

/**
 * Error which indicates a timeout
 */
export default class TimeoutError extends Error {

  /**
   * Constructs the timeout error
   * @param message error message
   */
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }

}
